import React from 'react';
import Item from './StatsItem';
import classNames from 'classnames';
import results from '../../data/results';

class StatsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showUs: false};
    this.onHoverUs = this.onHoverUs.bind(this);
    this.onLeaveUs = this.onLeaveUs.bind(this);
  }

  onHoverUs() {
    if(this.props.coverEnabled) this.setState({showUs: true});
  }

  onLeaveUs() {
    if(this.props.coverEnabled) this.setState({showUs: false});
  }

  render() {
    const {stats, coverEnabled, comparison} = this.props;
    const className = classNames(
      'results__stats-by-comparison',
      {'is-us-covered': coverEnabled && !this.state.showUs }
    );

    const items = [];

    for (const key in stats) {
      const result = results[key];

      if (result && result.visible) {
        items.push({
          name: key,
          data: stats[key],
          estimate: key == 'complete_load' ? stats.netlify_estimate : result.us
        });
      }
    }

    return (
      <div className={className}>
        <table onMouseLeave={this.onLeaveUs}>
          <thead>
            <tr>
              <th className="is-label">Report Card</th>
              <th className="is-them">Your Scores</th>
              {comparison && <th className="is-us">Scores on Netlify</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((stat, index) => <Item comparison={comparison} stat={stat} key={index} />)}
          </tbody>
        </table>
        <div className="results__stats__cover" onMouseEnter={this.onHoverUs}><span>How much better could it be?</span></div>
      </div>
    );
  }
}

StatsTable.propTypes = {
  stats: React.PropTypes.object.isRequired,
  coverEnabled: React.PropTypes.bool,
  comparison: React.PropTypes.bool
};

export default StatsTable;



// WEBPACK FOOTER //
// ./src/components/results/StatsTable.js